// type
import { ShopRemove } from "iconsax-react";
import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";
import { MdHome } from "react-icons/md";
import { BsBuildingFillAdd } from "react-icons/bs";
import { TbRulerMeasure } from "react-icons/tb";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { TbHomeCog } from "react-icons/tb";
import { MdOutlineHomeWork } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { IoMdNotifications } from "react-icons/io";
import { GrHostMaintenance } from "react-icons/gr";
import { PiCertificateFill } from "react-icons/pi";
import { GrStatusInfo } from "react-icons/gr";
import { 
  can_delete_notifications,
} from "../helper/permissionsCheck";
// icons
const icons = {
  navigation: MdHome,
  propertyType: TbHomeCog,
  amenities: BsBuildingFillAdd,
  flatSize: TbRulerMeasure,
  taxes: HiOutlineReceiptTax,
  notifications: IoMdNotifications,
  property: MdOutlineHomeWork,
  color: MdHome,
  shadow: MdHome,
  clients: FiUsers,
  maintenance: GrHostMaintenance,
};
// let permissionUser = localStorage.getItem("LoginData");
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    console.log(error, "er");
  }
}

const permissions = decryptedData
  ? JSON.parse(decryptedData)?.permissions
  : null;

const allowedPermissions =
  permissions && permissions.length !== 0
    ? permissions.map((permission) => permission?.permission)
    : [];

const permissionsAccessFunction = (brand) => {
  return (
    allowedPermissions &&
    allowedPermissions.length !== 0 &&
    allowedPermissions.some((permission) => permission.includes(brand))
  );
};
// ==============================|| MENU ITEMS - roles ||============================== //

// const domainParameter = permissionsAccessFunction('company') ? {
const domainParameter =
true
    ? {
        id: "domain-parameter",
        title: "Domain Parameter",
        icon: icons.navigation,
        type: "group",
        children: [
          // allowedPermissions.includes('get-company') ? {
          true
            ? {
                id: "certificationType",
                title: "Certification Type",
                type: "item",
                url: "/certificationsType/all-type",
                icon: PiCertificateFill,
                breadcrumbs: true,
              }
            : null,
        ].filter(Boolean),
      }
    : null;

export default domainParameter;
